import { Tooltip as AntdTooltip } from 'antd'
import { TooltipPropsWithTitle, TooltipRef } from 'antd/es/tooltip'
import cx from 'classnames'
import React from 'react'
import './styles.scss'
import { getContrastedColorTheme } from '@commutifi-fe/utils'

interface AppTooltipProps extends TooltipPropsWithTitle {
  hideArrow?: boolean
}

/**
 * This class is a wrap around [antd Tooltip](https://ant.design/components/tooltip/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 * Extended props:
 * @param hideArrow - set to true if you want to hide the displayed arrow on the tooltip
 */
export const Tooltip = React.forwardRef<TooltipRef, AppTooltipProps>(
  ({ className, color, hideArrow, ...props }, ref) => {
    const colorTheme = getContrastedColorTheme(color)
    return (
      <AntdTooltip
        ref={ref}
        {...props}
        color={color}
        overlayClassName={cx(
          'app-tooltip',
          colorTheme === 'dark' && 'app-tooltip-text--dark',
          hideArrow && 'app-tooltip-arrow--hidden',
          className
        )}
      />
    )
  }
)
Tooltip.displayName = 'Tooltip'

export default Tooltip
